import React from "react";
import OnScroll from "../../common/onscroll";

const Experience = ({ exp }) => {
  const items = exp?.tabs?.[0]?.details || [];

  return (
    <section
      id="my_experience_list"
      className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8"
    >
      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Career Timeline
          </p>
          <h2 className="font-display text-3xl font-bold text-skin-text md:text-4xl">
            Experience across frontend, full-stack, and immersive products
          </h2>
        </div>
      </div>

      <div className="relative space-y-6 before:absolute before:left-6 before:top-0 before:h-full before:w-px before:bg-white/15 md:before:left-1/2">
        {items.map((item, index) => (
          <OnScroll
            key={`${item.company}-${item.role}-${index}`}
            nclass={`relative md:grid md:grid-cols-2 md:gap-10 ${
              index % 2 === 0 ? "" : "md:[&>article]:md:col-start-2"
            }`}
          >
            <article className="relative ml-16 rounded-[1.75rem] border border-white/15 bg-black/10 p-6 shadow-glass md:ml-0">
              <span className="absolute -left-12 top-8 h-4 w-4 rounded-full border-4 border-[var(--accent)] bg-[var(--bg)] md:left-auto md:right-[-2.7rem] md:top-10" />
              <div className="flex items-start gap-4">
                <img
                  src={item.image}
                  alt={item.company}
                  className="h-16 w-16 rounded-2xl bg-white/90 p-2 object-contain"
                />
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.24em] text-skin-accentSoft">
                    {item.duration}
                  </p>
                  <h3 className="mt-2 font-display text-2xl font-semibold text-skin-text">
                    {item.role}
                  </h3>
                  <p className="text-sm text-skin-muted">
                    {item.company} • {item.location}
                  </p>
                </div>
              </div>

              <p className="mt-4 text-sm leading-7 text-skin-muted">
                {item.description}
              </p>

              <div className="mt-4 flex flex-wrap gap-2">
                {item.skills?.map((skill) => (
                  <span
                    key={skill}
                    className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-medium text-skin-text"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </article>
          </OnScroll>
        ))}
      </div>
    </section>
  );
};

export default Experience;
